import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ConstructionServicesIndustry from "@/pages/industries/ConstructionServicesIndustry";
export const Route = createFileRoute("/industries/construction-services")({ head: ({match}) => pageHead(match.pathname), component: () => (<ConstructionServicesIndustry />) });
